function getUFORouteName(route) {
  if (route.ufoName != null) {
    return route.ufoName;
  }
  return route.name;
}
export default getUFORouteName;